// eslint-disable-next-line no-useless-escape
const DOMAIN_REG_EXP = /[^\.]*\.[^.]*$/;

export namespace CookieService {
  export function setCookie(name: string, value: string, days?: number): void {
    if (!value || value === 'undefined') return

    const domain = (document.domain.match(DOMAIN_REG_EXP) || [])[0]; // repd.us
    let expires = '';

    if (days) {
      const date = new Date();

      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = 'Expires=' + date.toUTCString();
    }

    document.cookie = `${name}=${value || ''}; ${expires}; Path=/; Domain=${domain}`;
  }

  export function getCookie(name: string): string | null {
    const nameEQ = name + '=';
    const cookiesList = document.cookie.split(';');

    for (let i = 0; i < cookiesList.length; i++) {
      let cookie = cookiesList[i].trimStart();

      if (cookie.indexOf(nameEQ) === 0)
        return cookie.substring(nameEQ.length, cookie.length);
    }
    return null;
  }

  export function eraseCookie(name: string): void {
    const domain = (document.domain.match(DOMAIN_REG_EXP) || [])[0]; // repd.us

    document.cookie = name + `=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=${domain};`;
  }

  export function deleteAllCookies() {
    const cookies: string[] = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
      const cookie: string = cookies[i];
      const index = cookie.indexOf('=');
      const name = index > -1 ? cookie.substring(0, index) : cookie;

      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
    }
  }

  export function setLocalStorage(key: string, value: any, isJSON?: boolean): void {
    if (!value || value === 'undefined') return

    if (!isJSON)
      localStorage.setItem(key, value);
    else
      localStorage.setItem(key, JSON.stringify(value));
  }

  export function removeLocalStorage(key: string): void {
    localStorage.removeItem(key);
  }

  export function getLocalStorage(key: string, isJSON?: boolean): string | any {
    if (!isJSON)
      return localStorage.getItem(key);
    else {
      const storedItem = localStorage.getItem(key);

      if (storedItem && storedItem !== 'null') {
        let parsedItem = {};

        try {
          parsedItem = JSON.parse(storedItem);
        } catch (error) {
          console.warn('Issue with parsing stored value: ', error);
        }

        return parsedItem;
      } else
        return null;
    }
  }
}
